export const getRoutingList = (builder) => ({
    getRoutingList: builder.mutation({
        query: ({pageNumber, limit, route_name }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';

            return {
                url: '/get_list_of_routes',
                method: 'GET',
                params: { pageNumber, limit, route_name },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});
